import React, { Component } from 'react';
import defaultIcon from '../../images/default.png';
import styles from './index.less';

export default class ImageModule extends Component {
  render() {
    const { modules = [] } = this.props;
    return (
      <div className={styles.imageModule}>
        {modules.map(item => {
          return (
            <div style={{ backgroundImage: `url(${item.fileId || defaultIcon})` }}>
              <div>
                <i />
                <span>{item.moduleName}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
